import { connect } from 'react-redux'
import { compose } from 'redux'
import ListItemMoviePerformancesEditButton from '../presents/ListItemMoviePerformancesEditButton'
import { updateFlyerElement } from '../../../actions'
import toJS from '../../../hoc/toJS'
import hasSingleMovie from '../../../hoc/hasSingleMovie'
import ListItemMovieContainer from './ListItemMovieContainer'

const mapDispatchToProps = (dispatch) => ({
    onUpdate: (itemData, pk) => {
        dispatch(updateFlyerElement('moviePerformances', itemData, itemData.flyerPk))
    }
})

const enhance = compose(
    hasSingleMovie(),
    toJS()
)

const MovieContainer = ({itemType, movieData, isSelected, additionalButton, onDelete}) => {
    return <ListItemMovieContainer
        itemType={itemType}
        itemData={movieData}
        additionalClass=''
        isSelected={isSelected}
        additionalButton={additionalButton}
        pathnameEdit={false}
        onDelete={onDelete}
    />
}

const EnhancedMovieContainer = enhance(MovieContainer)

const ListItemMoviePerformancesContainer = ({
    itemType,
    itemData, 
    isSelected,
    onDelete, 
    flyerPk,
    onUpdate
}) => {
    if(!itemData || !itemData.movieId) {
        return ''
    } else {
        return <EnhancedMovieContainer 
            itemType={itemType}
            itemData={itemData}
            movieId={itemData.movieId}
            isSelected={isSelected}
            additionalButton={<ListItemMoviePerformancesEditButton
                itemData={itemData}
                flyerPk={flyerPk}
                onUpdate={onUpdate}
            />}
            onDelete={onDelete}
        />
    }
}

export default compose(
    connect(null, mapDispatchToProps),
    toJS()
)(ListItemMoviePerformancesContainer)